import type { SummaryTokenPayload, TokenSelectionContext, TokenSelectionResult } from './types';

export function selectTokenText(payload: SummaryTokenPayload, context: TokenSelectionContext): TokenSelectionResult {
  const previous = context.previousText;

  if (typeof payload.delta === 'string') {
    return { text: previous + payload.delta };
  }

  if (typeof payload.text === 'string' && payload.text.length >= previous.length) {
    return { text: payload.text };
  }

  return { text: previous };
}
